import { Clip } from '@goldcast/player-config/src/types/clip-types';
import {
  getPlayerTimeFromSegmentTime,
  getSegmentTimeFromPlayerTime
} from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/timeUtils';
import type { ChapterParagraph } from '@/components/molecules/Transcript/types';

export const getChapterPlayerTime = (chapter: ChapterParagraph, clipData: Clip, isSplitsEnabled: boolean): number => {
  return isSplitsEnabled ? chapter.start : getPlayerTimeFromSegmentTime(chapter.start, clipData, chapter.segmentId);
};

// Returns the time in recording/segment coordinate space, matching word.start_time in the
// transcript. Required for TimelineForcedScroll, which all other callers (SpeakerTimeline etc.)
// also dispatch in segment time — not player time.
// When splits is disabled, chapter.start is already recording time (no conversion needed).
// When splits is enabled, chapter.start is player time and must be converted.
export const getChapterSegmentTime = (chapter: ChapterParagraph, clipData: Clip, isSplitsEnabled: boolean): number => {
  return isSplitsEnabled ? getSegmentTimeFromPlayerTime(chapter.start, clipData, chapter.segmentId) : chapter.start;
};
